<div class="title-container">
  <h1 class="step-title">{{ selected!.label }}</h1>
  <div class="spinner-container">
    <mat-progress-spinner class="step-spinner" color="primary" mode="determinate" diameter="68" [value]="value" />
    <div class="step-inner-text">
      <h3>{{ currentDisplayedStep }}/{{ stepsIndex.length }}</h3>
    </div>
  </div>
</div>

<div class="step-content" [ngTemplateOutlet]="selected ? selected.content : null"></div>

<footer class="step-navigation-bar">
  <button mat-flat-button (click)="cancel()" mat-button>
    {{ 'shared.cancel' | translate | uppercase }}
  </button>
  <button
    [disabled]="!canContinue"
    mat-flat-button
    color="primary"
    *ngIf="currentDisplayedStep !== stepsIndex.length"
    (click)="selectNextStep()"
    mat-button
  >
    {{ 'shared.next' | translate | uppercase }}
  </button>
  <button
    [disabled]="!canContinue"
    mat-flat-button
    color="primary"
    *ngIf="currentDisplayedStep === stepsIndex.length"
    (click)="save()"
    mat-button
  >
    {{ 'shared.save' | translate | uppercase }}
  </button>
</footer>
